import React, { useState, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FiImage, FiPaperclip } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { useGlobal } from 'reactn';
import moment from 'moment';
import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import EmojiPicker from 'src/components/EmojiPicker';
import { UploadMultiFile } from 'src/components/upload';
import useResponsive from 'src/hooks/useResponsive';
//actions
import message from 'src/actions/chats/staff/message';
import uploadFile from 'src/actions/chats/staff/uploadFile';
import roundSend from '@iconify/icons-ic/round-send';
import {
    Box,
    CardContent,
    CardHeader,
    Button,
    Input,
    Divider,
    IconButton,
    InputAdornment,
    Stack,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogActions,
    Typography,
} from '@mui/material';
import { setMessage, getListaStaffsWithoutIsGroup } from 'src/redux/slices/staff';
import useAuth from 'src/hooks/useAuth';
import v2_actionChatInternoEnviarMsg from 'src/actions/v2/chats/chat-interno/v2_actionChatInternoEnviarMsg';
import ChatInternoMessageItem from './ChatInternoMessageItem';
import Iconify from 'src/components/Iconify';
import { getSessionStorageItem, setSessionStorageItem } from 'src/services/sessionStorage';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    minHeight: 72,
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
}));

const ChatInternoBottombar = ({ chat, selectedMessage, closeReplyMsg, isMiniChat }) => {
    const { t } = useTranslation();
    const ref = useRef(null);
    const { user } = useAuth();
    const [text, setText] = useState('');
    const { cliente } = useAuth();
    /* eslint-disable no-unused-vars */
    const [preview, setPreview] = useState(false);
    /* eslint-enable no-unused-vars */
    const [pictureRefs, addPictureRef] = useState([]);
    const isDesktop = useResponsive('up', 'md');
    const [loadingSendText, setLoadingSendText] = useState(false);
    //multifile
    const [multiFile, setMultiFile] = useState(false);
    const [multiImages, setMultiImages] = useState(false);
    const [loadingEnviarArquivos, setLoadingEnviarArquivos] = useState(false);
    const [files, setFiles] = useState([]);
    const [images, setImages] = useState([]);
    const [errorDialog, setErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();

    const handleKeyUp = (event) => {
        if (!event.shiftKey && event.key === 'Enter') {
            sendMessage();
        }
    };

    const onChangeText = (e) => {
        setText(e.target.value);
    };

    const handleDropMultiFile = useCallback(
        (acceptedFiles) => {
            for (let i = 0; i < acceptedFiles.length; i++) {
                if (acceptedFiles[i].size / (1024 * 1024) > 20) return alert(t('chat.internal.bottombar.fileSizeExceeded'));
            }
            setFiles(acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })));
            setMultiFile(true);
        },
        [setFiles, t]
    );

    const handleDropMultiImages = useCallback(
        (acceptedFiles) => {
            for (let i = 0; i < acceptedFiles.length; i++) {
                if (acceptedFiles[i].size / (1024 * 1024) > 20) {
                    setErrorMessage(t('chat.internal.bottombar.fileSizeExceeded'));
                    setErrorDialog(true);
                    return;
                }
                if (!acceptedFiles[i].type.startsWith('image/')) {
                    setErrorMessage(
                        t('chat.internal.bottombar.onlyImagesAllowed')
                    );
                    setErrorDialog(true);
                    return;
                }
            }
            setImages(acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })));
            setMultiImages(true);
        },
        [setImages, t]
    );

    const handleRemoveAll = () => {
        setFiles([]);
        setImages([]);
    };

    const handleRemove = (file) => {
        const filteredItems = files.filter((_file) => _file !== file);
        setFiles(filteredItems);
        const filteredItemsImages = images.filter((_file) => _file !== file);
        setImages(filteredItemsImages);
    };

    function onChangeAnexo2() {
        if (files.length > 0) {
            setLoadingEnviarArquivos(true);
            sendFiles(files);
        }
    }

    function onChangeAnexo3() {
        if (images.length > 0) {
            setLoadingEnviarArquivos(true);
            sendImages(images);
        }
    }

    const handleOnPaste = (event) => {
        console.log({ event });
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;
        console.log('items:', JSON.stringify(items));
        let blob = null;
        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') === 0) {
                blob = items[i].getAsFile();
            }
        }
        if (blob !== null) {
            if (blob.type === 'image/png') {
                console.log('blob', blob);
                setImages([Object.assign(blob, { preview: URL.createObjectURL(blob) })]);
                setMultiImages(true);
            } else {
                console.log('blob', blob);
                setFiles([Object.assign(blob, { preview: URL.createObjectURL(blob) })]);
                setMultiFile(true);
            }
        }
    };

    async function sendMessage() {
        setLoadingSendText(true);
        if (text.length === 0) return;
        try {
            const result = await v2_actionChatInternoEnviarMsg(chat._id, {
                author: user.id,
                text: text,
                ...(selectedMessage && { replyMsg: selectedMessage }),
            });
            dispatch(getListaStaffsWithoutIsGroup());
            setLoadingSendText(false);
            let res_message = result.data.data;
            let newMessage = {
                _id: res_message._id,
                author: { ...user, _id: user.id },
                content: text,
                type: 'text',
                date: moment(),
                ...(selectedMessage && { replyMsg: selectedMessage }),
            };
            dispatch(setMessage(newMessage));
            setText('');
            if (selectedMessage) {
                closeReplyMsg();
            }
            const activeMiniChat = getSessionStorageItem('chatInternoMiniId');
            if (activeMiniChat && activeMiniChat._id === chat._id) {
                const newMessages = [...(activeMiniChat.messages || []), newMessage];
                const updatedChat = { ...activeMiniChat, messages: newMessages };
                setSessionStorageItem('chatInternoMiniId', updatedChat);
            }
        } catch (error) {
            console.log(error);
            setLoadingSendText(false);
        }
    }

    const sendImages = async (images) => {
        setLoadingSendText(true);
        for (let i = 0; i < images.length; i++) {
            if (images[i].size / (1024 * 1024) > 20) return alert(t('chat.internal.bottombar.fileSizeExceeded'));
        }
        let tmpRefs = [];
        for (let i = 0; i < images.length; i++) {
            const file = images[i];
            tmpRefs.push(ref + i);
            const res = await uploadFile(file, ref + i);
            message({
                clienteId: user.clienteId,
                roomID: chat._id,
                authorID: user.id,
                content: res.data.file.shieldedID,
                type: 'image',
                fileID: res.data.file._id,
            });
            let newMessage = {
                _id: Math.random(),
                author: { ...user, _id: user.id },
                content: res.data.file.shieldedID,
                type: 'image',
                date: moment(),
                file: res.data.file,
            };
            dispatch(setMessage(newMessage));
            setLoadingSendText(false);
            setLoadingEnviarArquivos(false);
            setMultiImages(false);
            setImages([]);
            const activeMiniChat = getSessionStorageItem('chatInternoMiniId');
            if (activeMiniChat && activeMiniChat._id === chat._id) {
                const newMessages = [...(activeMiniChat.messages || []), newMessage];
                const updatedChat = { ...activeMiniChat, messages: newMessages };
                setSessionStorageItem('chatInternoMiniId', updatedChat);
            }
        }
        addPictureRef([...pictureRefs, ...tmpRefs]);
        dispatch(getListaStaffsWithoutIsGroup());
    };

    const sendFiles = async (files) => {
        setLoadingSendText(true);
        for (let i = 0; i < files.length; i++) {
            if (files[i].size / (1024 * 1024) > 20) return alert(t('chat.internal.bottombar.fileSizeExceeded'));
        }
        let tmpRefs = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            tmpRefs.push(ref + i);
            console.log(file.type);
            const res = await uploadFile(file, ref + i);
            message({
                clienteId: user.clienteId,
                roomID: chat._id,
                authorID: user.id,
                content: res.data.file.shieldedID,
                type: 'file',
                fileID: res.data.file._id,
            });
            let newMessage = {
                _id: Math.random(),
                author: { ...user, _id: user.id },
                content: res.data.file.shieldedID,
                type: 'file',
                date: moment(),
                file: res.data.file,
            };
            dispatch(setMessage(newMessage));
            setLoadingSendText(false);
            setLoadingEnviarArquivos(false);
            setMultiFile(false);
            setFiles([]);
            const activeMiniChat = getSessionStorageItem('chatInternoMiniId');
            if (activeMiniChat && activeMiniChat._id === chat._id) {
                const newMessages = [...(activeMiniChat.messages || []), newMessage];
                const updatedChat = { ...activeMiniChat, messages: newMessages };
                setSessionStorageItem('chatInternoMiniId', updatedChat);
            }
        }
        addPictureRef([...pictureRefs, ...tmpRefs]);
        dispatch(getListaStaffsWithoutIsGroup());
    };

    return (
        <div className="flex flex-col sticky bottom-0 z-50 backdrop-blur-md border-t border-gray-100/50 dark:border-[#2A2A2A]/50 transition-all duration-300">
            {!!selectedMessage && (
                <div className="px-4 pt-3 pb-1 animate-in slide-in-from-bottom-2 fade-in duration-300">
                    <div className="flex items-center justify-between p-3 bg-white/60 dark:bg-[#1A1A1A]/60 backdrop-blur-md border border-indigo-500/20 rounded-2xl shadow-sm relative overflow-hidden group">
                        <div className="absolute left-0 top-0 bottom-0 w-1 bg-indigo-600 group-hover:w-1.5 transition-all duration-300" />
                        <div className="flex flex-col ml-3 flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-0.5">
                                <Iconify icon="solar:reply-bold" className="w-3.5 h-3.5 text-indigo-600" />
                                <Typography
                                    variant="caption"
                                    className="text-indigo-600 font-bold uppercase tracking-wider text-[10px]"
                                >
                                    {t('chat.internal.bottombar.replyingTo', { name: selectedMessage.author?.name || t('chat.messageList.user') })}
                                </Typography>
                            </div>
                            <Typography variant="body2" className="text-gray-600 dark:text-[#ABABAD] truncate text-[13px] pl-5.5">
                                {selectedMessage.content || (selectedMessage.file ? `📎 ${t('chat.internal.bottombar.attachment')}` : '')}
                            </Typography>
                        </div>
                        <IconButton
                            size="small"
                            onClick={closeReplyMsg}
                            className="ml-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition-all duration-200"
                        >
                            <Iconify icon="solar:close-circle-bold" width={20} height={20} />
                        </IconButton>
                    </div>
                </div>
            )}

            <Dialog fullWidth open={multiFile} onClose={() => setMultiFile(false)}>
                <DialogContent>
                    <Box
                        component="form"
                        noValidate
                        sx={{ margin: 'auto', display: 'flex', width: 'fit-content', flexDirection: 'column' }}
                    >
                        <Stack spacing={2}>
                            <CardHeader title={t('chat.internal.bottombar.sendFiles')} />
                            <CardContent>
                                <UploadMultiFile
                                    isStaff={true}
                                    cliente={cliente}
                                    isDocument={false}
                                    changeIsDocument={() => { }}
                                    loadingEnviarArquivos={loadingEnviarArquivos}
                                    showPreview={preview}
                                    files={files}
                                    onEnviarArquivos={onChangeAnexo2}
                                    onDrop={handleDropMultiFile}
                                    onRemove={handleRemove}
                                    onRemoveAll={handleRemoveAll}
                                />
                            </CardContent>
                        </Stack>
                    </Box>
                </DialogContent>
                <DialogActions className="p-4 border-t border-gray-100 bg-gray-50/50">
                    <Button
                        onClick={() => setMultiFile(false)}
                        className="text-gray-500 hover:bg-gray-100 hover:text-gray-700 rounded-xl px-6"
                        variant="text"
                    >
                        {t('common.buttons.close')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog fullWidth open={multiImages} onClose={() => setMultiImages(false)}>
                <DialogContent>
                    <Box
                        component="form"
                        noValidate
                        sx={{ margin: 'auto', display: 'flex', width: 'fit-content', flexDirection: 'column' }}
                    >
                        <Stack spacing={2}>
                            <CardHeader title={t('chat.internal.bottombar.sendImages')} />
                            <CardContent>
                                <UploadMultiFile
                                    isStaff={true}
                                    cliente={cliente}
                                    isDocument={false}
                                    changeIsDocument={() => { }}
                                    loadingEnviarArquivos={loadingEnviarArquivos}
                                    showPreview={preview}
                                    files={images}
                                    onEnviarArquivos={onChangeAnexo3}
                                    onDrop={handleDropMultiImages}
                                    onRemove={handleRemove}
                                    onRemoveAll={handleRemoveAll}
                                />
                            </CardContent>
                        </Stack>
                    </Box>
                </DialogContent>
                <DialogActions className="p-4 border-t border-gray-100 bg-gray-50/50">
                    <Button
                        onClick={() => setMultiImages(false)}
                        className="text-gray-500 hover:bg-gray-100 hover:text-gray-700 rounded-xl px-6"
                        variant="text"
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={errorDialog}
                onClose={() => setErrorDialog(false)}
                PaperProps={{ sx: { borderRadius: 2, maxWidth: 400, width: '100%' } }}
            >
                <DialogContent sx={{ pb: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2 }}>
                        <Iconify icon="material-symbols:error-outline" sx={{ fontSize: 48, color: 'error.main', mb: 2 }} />
                        <Typography color="error" variant="h6" align="center" sx={{ fontWeight: 500, mb: 1 }}>
                            {t('chat.internal.bottombar.attention')}
                        </Typography>
                        <Typography variant="body2" align="center" sx={{ color: 'text.secondary', px: 2 }}>
                            {errorMessage}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button onClick={() => setErrorDialog(false)} variant="contained" color="error" sx={{ borderRadius: 1, px: 3, py: 1 }}>
                        {t('chat.internal.bottombar.understood')}
                    </Button>
                </DialogActions>
            </Dialog>

            <div className={isMiniChat ? 'px-2 py-1.5' : 'p-2 pt-2'}>
                {isMiniChat ? (
                    /* Mini Chat: layout compacto - input com ações inline */
                    <div className="flex items-center gap-1 bg-white dark:bg-[#1A1A1A] border border-gray-200 dark:border-[#383838] rounded-full px-1 focus-within:border-[#7C3AED] focus-within:ring-1 focus-within:ring-[#7C3AED]/20 transition-all">
                        <Input
                            disabled={loadingSendText}
                            fullWidth
                            onChange={onChangeText}
                            onPaste={handleOnPaste}
                            disableUnderline
                            autoFocus
                            onKeyPress={handleKeyUp}
                            value={text}
                            placeholder={t('chat.internal.bottombar.messagePlaceholderShort')}
                            sx={{
                                flex: 1,
                                py: 0.75,
                                px: 1.5,
                                fontSize: '0.8rem',
                                color: 'text.primary',
                                '& .MuiInputBase-input::placeholder': { color: 'text.secondary', opacity: 0.6 },
                            }}
                        />
                        <div className="flex items-center gap-0 shrink-0">
                            {user.isSendFileStaff && (
                                <IconButton
                                    onClick={() => setMultiFile(true)}
                                    size="small"
                                    sx={{
                                        color: 'text.disabled',
                                        width: 28,
                                        height: 28,
                                        '&:hover': { color: '#7C3AED', backgroundColor: 'rgba(124, 58, 237, 0.08)' },
                                    }}
                                >
                                    <Iconify icon="eva:attach-outline" width={16} height={16} />
                                </IconButton>
                            )}
                            {loadingSendText ? (
                                <div className="w-7 h-7 flex items-center justify-center">
                                    <CircularProgress size={16} thickness={6} sx={{ color: '#7C3AED' }} />
                                </div>
                            ) : (
                                <IconButton
                                    disabled={!text}
                                    onClick={sendMessage}
                                    sx={{
                                        width: 28,
                                        height: 28,
                                        borderRadius: '50%',
                                        color: text ? 'white' : 'text.disabled',
                                        backgroundColor: text ? '#7C3AED' : 'transparent',
                                        '&:hover': { backgroundColor: text ? '#6d28d9' : 'transparent' },
                                        transition: 'all 0.2s',
                                    }}
                                >
                                    <Iconify icon="eva:arrow-upward-fill" width={16} height={16} />
                                </IconButton>
                            )}
                        </div>
                    </div>
                ) : (
                    /* Chat normal: layout completo */
                    <div className="flex items-end gap-3 p-1.5 bg-slate-50/80 dark:bg-[#1A1A1A]/80 hover:bg-slate-100/80 dark:hover:bg-[#222529]/80 focus-within:bg-white dark:focus-within:bg-[#1A1A1A] focus-within:ring-2 focus-within:ring-indigo-500/20 focus-within:border-indigo-500/30 border border-slate-200 dark:border-[#383838] hover:border-slate-300 dark:hover:border-[#565856] rounded-2xl transition-all duration-300 ease-out shadow-sm">
                        <div className="flex items-center pb-1 gap-1.5 pl-1">
                            {isDesktop && (
                                <div className="hover:bg-gray-200/80 dark:hover:bg-[#383838] rounded-full transition-colors p-1">
                                    <EmojiPicker value={text} setValue={setText} />
                                </div>
                            )}
                            {user.isSendFileStaff && (
                                <>
                                    <IconButton
                                        onClick={() => setMultiImages(true)}
                                        size="small"
                                        className="group"
                                        sx={{
                                            color: 'text.secondary',
                                            width: 34,
                                            height: 34,
                                            borderRadius: '10px',
                                            '&:hover': { color: '#4F46E5', backgroundColor: 'rgba(79, 70, 229, 0.08)' },
                                            transition: 'all 0.2s',
                                        }}
                                    >
                                        <Iconify icon="solar:gallery-add-bold" width={20} height={20} />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => setMultiFile(true)}
                                        size="small"
                                        className="group"
                                        sx={{
                                            color: 'text.secondary',
                                            width: 34,
                                            height: 34,
                                            borderRadius: '10px',
                                            '&:hover': { color: '#4F46E5', backgroundColor: 'rgba(79, 70, 229, 0.08)' },
                                            transition: 'all 0.2s',
                                        }}
                                    >
                                        <Iconify icon="solar:paperclip-bold" width={20} height={20} />
                                    </IconButton>
                                </>
                            )}
                        </div>
                        <Input
                            disabled={loadingSendText}
                            fullWidth
                            onChange={onChangeText}
                            multiline={!loadingSendText}
                            onPaste={handleOnPaste}
                            maxRows={8}
                            disableUnderline
                            autoFocus
                            onKeyPress={handleKeyUp}
                            value={text}
                            placeholder={t('chat.internal.bottombar.messagePlaceholder')}
                            sx={{
                                flex: 1,
                                py: 1,
                                px: 1.5,
                                fontSize: '0.95rem',
                                color: 'text.primary',
                                '& .MuiInputBase-input::placeholder': { color: 'text.secondary', opacity: 0.8 },
                            }}
                        />
                        <div className="pb-1 flex items-center pr-1">
                            {loadingSendText ? (
                                <div className="p-2 flex items-center justify-center">
                                    <CircularProgress size={20} thickness={6} sx={{ color: '#7C3AED' }} />
                                </div>
                            ) : (
                                <IconButton
                                    disabled={!text}
                                    onClick={sendMessage}
                                    className={`transition-all duration-300 ease-out ${text
                                            ? 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-md shadow-indigo-200 dark:shadow-indigo-900/30'
                                            : 'bg-slate-100 dark:bg-[#222529] text-slate-400 dark:text-[#71717A] cursor-not-allowed'
                                        }`}
                                    sx={{
                                        width: 36,
                                        height: 36,
                                        borderRadius: '12px',
                                        '&:hover': { backgroundColor: text ? '#4338CA' : '#F1F5F9' },
                                    }}
                                >
                                    <Iconify
                                        icon="solar:plain-3-bold"
                                        width={20}
                                        height={20}
                                        className={text ? 'translate-x-[1px]' : ''}
                                    />
                                </IconButton>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChatInternoBottombar;